var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1 14.75a1 1 0 0 1 .993.883l.007.117v2.85a2.903 2.903 0 0 1-2.73 2.895l-.17.005H2.9a2.903 2.903 0 0 1-2.895-2.73L0 18.6v-2.85a1 1 0 0 1 1.993-.117L2 15.75v2.85c0 .457.345.837.788.893l.112.007h13.3a.903.903 0 0 0 .893-.787l.007-.113v-2.85a1 1 0 0 1 1-1zM9.402.511l.073-.008L9.604.5l.12.014.138.035.111.044.098.052.104.074.082.073 3.8 3.8a1 1 0 0 1-1.32 1.497l-.094-.083-2.094-2.093.001 10.886a1 1 0 0 1-.883.993l-.117.007a1 1 0 0 1-.993-.883L8.55 14.8 8.549 3.914 6.457 6.007a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1-.083-1.32l.083-.094 3.8-3.8.112-.097.11-.071L9.18.57l.105-.035.118-.025z",
    fill: "currentColor",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b67a4ee7e31e4fd6a559e8ae95e0a4a0.svg";
export { ForwardRef as ReactComponent };